export const CSS = {
  base: '/base.css',
  menu: '/menu.css',
  lobby: '/lobby.css',
  round: '/round.css'
}

// attach once, skip if a stylesheet already exists
export function attachStylesheet(href) {
  if (document.head.querySelector(`link[rel="stylesheet"][href="${href}"]`) != null) return
  const link = document.createElement('link')
  link.rel = 'stylesheet'
  link.href = href
  document.head.appendChild(link)
}

// hint early fetch (hover / before navigation)
export function preloadCss(href) {
  if (document.head.querySelector(`link[href="${href}"]`) != null) return
  const link = document.createElement('link')
  link.rel = 'preload'
  link.as = 'style'
  link.href = href
  document.head.appendChild(link)
}

const MENU_LOBBY_PRELOAD =
  '.room-card, [data-role="create-game"], [data-role="join-public"], [data-role="join-private"], [data-role="toggle-private"], [data-role="join-code"]'

// lobby.css on room/join hover; round on Ready hover
export function setupCssHoverPreload(mainEl) {
  const onMenuHover = e => {
    const t = e.target
    if (!(t instanceof Element)) return
    if (t.closest(MENU_LOBBY_PRELOAD)) preloadCss(CSS.lobby)
  }

  const onReadyHover = e => {
    const t = e.target
    if (!(t instanceof Element)) return
    if (t.closest('[data-role="toggle-ready"]')) preloadCss(CSS.round)
  }

  mainEl.addEventListener('mouseover', onMenuHover, true)
  mainEl.addEventListener('mouseover', onReadyHover, true)

  return () => {
    mainEl.removeEventListener('mouseover', onMenuHover, true)
    mainEl.removeEventListener('mouseover', onReadyHover, true)
  }
}
